import { BackgroundType } from '@rsa-digital/evo-shared-components/components/Background';
import { graphql } from 'gatsby';
import React from 'react';
import {
  processImageAsset,
  processOptionalCta,
  unwrapSingleton,
} from 'helpers/csTypeProcessors';
import { CsAsset, CsCta, CsIcon } from 'types/contentStack';
import { StyledFeature } from './styles';

export type FeatureBlockData = {
  html_id?: string;
  title: string;
  subtitle: string | null;
  body: string;
  cta: [CsCta] | null;
  secondary_cta: [CsCta] | null;
  image: CsAsset | null;
  custom_bullet_icon: [CsIcon] | [];
  invert_content: boolean;
  invert_content_on_mobile: boolean;
  render_image_as_link: boolean;
  should_use_primary_cta: boolean;
  display_background: boolean;
  background_type?: BackgroundType;
};

type FeatureBlockProps = {
  feature: FeatureBlockData;
};

export const query = graphql`
  fragment FeatureBlock on cs__feature {
    html_id
    title
    subtitle
    body
    cta {
      ...Cta
    }
    secondary_cta {
      ...Cta
    }
    image {
      ...Asset
    }
    custom_bullet_icon {
      ...Icon
    }
    invert_content
    invert_content_on_mobile
    render_image_as_link
    should_use_primary_cta
    display_background
    background_type
  }
`;

const FeatureBlock: React.FC<FeatureBlockProps> = ({ feature }) => (
  <StyledFeature
    id={feature.html_id}
    data-cy="Feature"
    title={feature.title}
    subtitle={feature.subtitle ?? undefined}
    body={feature.body}
    cta={processOptionalCta(feature.cta, 'FeatureCta')}
    secondaryCta={processOptionalCta(feature.secondary_cta, 'FeatureSecondaryCta')}
    image={processImageAsset(feature.image)}
    customBulletIcon={unwrapSingleton(feature.custom_bullet_icon)?.icon_code}
    invertContent={feature.invert_content}
    invertContentOnMobile={feature.invert_content_on_mobile}
    renderImageAsLink={feature.render_image_as_link}
    shouldUsePrimaryCta={feature.should_use_primary_cta}
    displayBackground={feature.display_background}
    backgroundType={feature.background_type}
  />
);
export default React.memo(FeatureBlock);
